// menu
var menuToggle = document.getElementById("menu--toggle");
var menu = document.getElementById("site--navigation");
var body = document.getElementsByTagName("BODY")[0];

menuToggle.addEventListener("click", function (e) {
  e.preventDefault();

  if (menuToggle.classList.contains("open")) {
    body.classList.remove("main-menu--open");
    menu.classList.remove("open");
    menuToggle.classList.remove("open");
    menuToggle.setAttribute("aria-expanded", false);
  } else {
    body.classList.add("main-menu--open");
    menu.classList.add("open");
    menuToggle.classList.add("open");
    menuToggle.setAttribute("aria-expanded", true);
  }
});

// sub nav drop down
var navWithChildren = document.getElementsByClassName("menu-item-has-children");
for (var x = 0; x < navWithChildren.length; x++) {
  var primaryMenu = document.getElementById("primary--menu");
  var parentLink = navWithChildren[x];
  var subMenu = parentLink.getElementsByClassName("sub-menu")[0];
  var subToggle = document.createElement("button");
  var newSpan = document.createElement("span");
  newSpan.classList.add("sr-only");
  newSpan.innerHTML = "Submenu Toggle";
  subToggle.classList.add("sub-menu-toggle");
  subToggle.appendChild(newSpan);
  parentLink.insertBefore(subToggle, subMenu);
}

var subToggles = document.getElementsByClassName("sub-menu-toggle");
for (var x = 0; x < subToggles.length; x++) {
  var primaryMenu = document.getElementById("primary--menu");
  subToggles[x].addEventListener("click", function (e) {
    e.preventDefault();

    var open_flag = 0;
    if (e.target.parentNode.classList.contains("open")) {
      open_flag = 1;
    }

    for (var y = 0; y < navWithChildren.length; y++) {
      navWithChildren[y].classList.remove("open");
    }

    if (open_flag === 1) {
      e.target.parentNode.classList.remove("open");
      primaryMenu.classList.remove("subopen");
    } else {
      e.target.parentNode.classList.add("open");
      primaryMenu.classList.add("subopen");
    }
  });
}
